// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.page-content {
  width: 100%;
  min-width: var(--page-min-width);
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1 1;
  background-color: var(--color-bg);
  --page-header-height: 96px;
  /* モバイル */
  /* タブレット */
  /* PC */
}
@media (width < 752px) {
  .page-content {
    --page-min-width: 100vw;
  }
}
@media (752px <= width < 1122px) {
  .page-content {
    --page-min-width: 320px;
  }
}
@media (1122px <= width) {
  .page-content {
    --page-min-width: 480px;
  }
}
.page-content .scene-root {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.page-content .page-wrapper {
  width: 100%;
  min-width: var(--page-min-width);
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex: 1 1;
}
.page-content .page-header-container {
  width: 100%;
  margin-left: auto;
  box-sizing: border-box;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  min-width: var(--page-min-width);
  height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.page-content .page-header-container .page-header-title {
  font-size: var(--text-size-x-large);
  font-weight: 800;
}
.page-content .page-header-container .page-header-detail {
  font-size: var(--text-size-normal);
}
.page-content .page-header {
  width: 100%;
  min-width: var(--page-min-width);
  height: var(--page-header-height);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.page-content .page-scroll-parent {
  width: 100%;
  height: calc(100vh - var(--page-header-height));
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  overflow-y: scroll;
  overflow-x: hidden;
}
.page-content .page-scroll-parent.isHeader {
  height: calc(100vh - var(--page-header-height) - var(--header-height));
}
.page-content .page-container-parent {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.page-content .page-container-parent.isHeader {
  height: calc(100vh - var(--page-header-height) - var(--header-height));
}
.page-content .page-container {
  width: 100%;
  height: fit-content;
  margin-left: auto;
  box-sizing: border-box;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  min-width: var(--page-min-width);
  padding: 16px;
  margin-bottom: 60px;
}
.page-content .side-content {
  height: 100%;
  width: 100%;
  min-width: 360px;
  max-width: 360px;
  transition: min-width 0.3s;
  overflow-x: hidden;
  flex: 2 1;
}
.page-content .side-content .side-fixed-button {
  position: fixed; /* 位置を固定 */
  right: 16px; /* 右端から0pxの位置に設定 */
  top: 50%; /* 画面の上から50%の位置に設定 (画面の中央に垂直方向で配置) */
  transform: translateY(-50%); /* Y軸方向の中心を基点として移動させることで、ボタンが完全に垂直中央にくるよう調整 */
}
.page-content .side-content.side-close {
  width: 0px !important;
  min-width: 0px !important;
  flex: 0 1 !important;
}
.page-content .side-scroll-parent {
  width: 320px;
  height: calc(100vh - var(--page-header-height));
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex: 1 1;
  overflow-y: scroll;
}
.page-content .side-container {
  width: 320px;
  min-width: 320px;
  margin-left: auto;
  box-sizing: border-box;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/common/layout_element/LayoutElement.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACI,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,iCAAA;EAEA,0BAAA;EAEA,SAAA;EAKA,UAAA;EAKA,OAAA;AATJ;AAAI;EAdJ;IAeQ,uBAAA;EAGN;AACF;AAAI;EAnBJ;IAoBQ,uBAAA;EAGN;AACF;AAAI;EAxBJ;IAyBQ,uBAAA;EAGN;AACF;AADI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAGR;AAAI;EACI,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAER;AACI;EACI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACR;AACQ;EACI,mCAAA;EACA,gBAAA;AACZ;AACQ;EACI,kCAAA;AACZ;AAGI;EACI,WAAA;EACA,gCAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,+CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAFR;AAIQ;EAEI,sEAAA;AAHZ;AAOI;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AALR;AAOQ;EAEI,sEAAA;AANZ;AAUI;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;AARR;AAWI;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;AATR;AAWQ;EACI,eAAA,EAAA,UAAA;EACA,WAAA,EAAA,kBAAA;EACA,QAAA,EAAA,oCAAA;EACA,2BAAA,EAAA,6CAAA;AATZ;AAYQ;EACI,qBAAA;EACA,yBAAA;EACA,oBAAA;AAVZ;AAcI;EACI,YAAA;EACA,+CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAZR;AAeI;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAbR","sourcesContent":["\r\n.page-content {\r\n    width: 100%;\r\n    min-width: var(--page-min-width);\r\n    height: fit-content;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    background-color: var(--color-bg);\r\n\r\n    --page-header-height: 96px;\r\n\r\n    /* モバイル */\r\n    @media (width < 752px) {\r\n        --page-min-width: 100vw;\r\n    }\r\n    \r\n    /* タブレット */\r\n    @media (752px <= width < 1122px) {\r\n        --page-min-width: 320px;\r\n    }\r\n    \r\n    /* PC */\r\n    @media (1122px <= width) {\r\n        --page-min-width: 480px;\r\n    }\r\n\r\n    .scene-root{\r\n        width: 100%;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: row;\r\n    }\r\n\r\n    .page-wrapper {\r\n        width: 100%;\r\n        min-width: var(--page-min-width);\r\n        height: fit-content;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        flex: 1;\r\n    }\r\n\r\n    .page-header-container {\r\n        width: 100%;\r\n        margin-left: auto;\r\n        box-sizing: border-box;\r\n        margin-right: auto;\r\n        padding-left: 16px;\r\n        padding-right: 16px;\r\n        min-width: var(--page-min-width);\r\n        height: 100%;\r\n        padding: 16px;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n\r\n        .page-header-title{\r\n            font-size: var(--text-size-x-large);\r\n            font-weight: 800;\r\n        }\r\n        .page-header-detail{\r\n            font-size: var(--text-size-normal);\r\n        }\r\n    }\r\n\r\n    .page-header {\r\n        width: 100%;\r\n        min-width: var(--page-min-width);\r\n        height: var(--page-header-height);\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex-direction: row;\r\n    }\r\n\r\n    .page-scroll-parent {\r\n        width: 100%;\r\n        height: calc(100vh - var(--page-header-height));\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        overflow-y: scroll;\r\n        overflow-x: hidden;\r\n\r\n        &.isHeader\r\n        {\r\n            height: calc(100vh - var(--page-header-height) - var(--header-height));\r\n        }\r\n    }\r\n\r\n    .page-container-parent {\r\n        width: 100%;\r\n        height: fit-content;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex-direction: row;\r\n\r\n        &.isHeader\r\n        {\r\n            height: calc(100vh - var(--page-header-height) - var(--header-height));\r\n        }\r\n    }\r\n\r\n    .page-container {\r\n        width: 100%;\r\n        height: fit-content;\r\n        margin-left: auto;\r\n        box-sizing: border-box;\r\n        margin-right: auto;\r\n        padding-left: 16px;\r\n        padding-right: 16px;\r\n        min-width: var(--page-min-width);\r\n        padding: 16px;\r\n        margin-bottom: 60px;\r\n    }\r\n\r\n    .side-content {\r\n        height: 100%;\r\n        width: 100%;\r\n        min-width: 360px;\r\n        max-width: 360px;\r\n        transition: min-width 0.3s;\r\n        overflow-x: hidden;\r\n        flex: 2;\r\n\r\n        .side-fixed-button {\r\n            position: fixed;     /* 位置を固定 */\r\n            right: 16px;         /* 右端から0pxの位置に設定 */\r\n            top: 50%;            /* 画面の上から50%の位置に設定 (画面の中央に垂直方向で配置) */\r\n            transform: translateY(-50%);  /* Y軸方向の中心を基点として移動させることで、ボタンが完全に垂直中央にくるよう調整 */\r\n        }\r\n\r\n        &.side-close{\r\n            width: 0px !important;\r\n            min-width: 0px !important;\r\n            flex: 0 !important;\r\n        }\r\n    }\r\n\r\n    .side-scroll-parent {\r\n        width: 320px;\r\n        height: calc(100vh - var(--page-header-height));\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        flex: 1;\r\n        overflow-y: scroll;\r\n    }\r\n\r\n    .side-container {\r\n        width: 320px;\r\n        min-width: 320px;\r\n        margin-left: auto;\r\n        box-sizing: border-box;\r\n        margin-right: auto;\r\n        padding-left: 16px;\r\n        padding-right: 16px;\r\n        height: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
